import React from 'react';
import styles from './SidebarTabs.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const SidebarTabs = ({ options, currentState, onClick, mini }) => {

    const { t } = useTranslation();

    return <ul className={cx(styles.tabsList, { [styles.mini]: mini })}>
        {options.map(item => (
            <li
                key={item.TERM}
                className={cx(styles.listItem, { [styles.activeTab]: item.TYPE === currentState })}
                onClick={() => onClick(item.TYPE)}
            >
                {t(item.TERM)}
            </li>
        ))}
    </ul>
}

export default SidebarTabs;